module.exports = "img/16.96222c.webp";